module.exports = __webpack_public_path__ + "img/help.b4515570.svg";